export default __webpack_public_path__ + "static/media/Daily.f67be064.svg";